// extracted by mini-css-extract-plugin
export default {"badge":"UserBadge_badge__y0F6Z","avatar":"UserBadge_avatar__SQQJB","name":"UserBadge_name__YJ6RY","actions":"UserBadge_actions__c19cy"};